var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReports = function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M17.1 7h3.6l-6.6 6.6-4-4-8 8V7h5V2h7v8h2V0H4.7L.1 4.6v17.8l10-10 4 4 8-8V12h2V5h-7zm-12-4.6V5H2.5zM14.1 22h-12v2h14v-5h-2z"
  })));
};
export default SvgReports;